import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { AttributesViewSaveAttributes } from './attributes-store/attributes.actions';
import * as attributesSelectors from './attributes-store/attributes.selector';
import { Attributes } from './attributes-store/attributes.state';
import { AttributesComponent } from './attributes.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'era-attributes',
  templateUrl: './attributes.container.html',
  imports: [AttributesComponent],
})
export class AttributesContainerComponent {
  private readonly store = inject(Store);

  public readonly attributes = this.store.selectSignal(attributesSelectors.selectCurentAttributes);

  public save(attributes: Attributes) {
    this.store.dispatch(new AttributesViewSaveAttributes({ attributes: attributes }));
  }
}
